import React, { ComponentProps, JSXElementConstructor, useState } from "react";

interface ModalTriggerWrapperProps {
  children: any;
  onBeforeTrigger?: (open: () => void) => void;
}

const ModalTriggerWrapper = <T extends keyof JSX.IntrinsicElements | JSXElementConstructor<any>>(ModalComp: T): (P: ModalTriggerWrapperProps & Omit<ComponentProps<T>, 'visible' | 'onCancel'>) => React.ReactNode => {
  
  return ({ children, onBeforeTrigger, ...rest }) => {
    const [visible, setVisible] = useState(false);

    const handleCancel = () => {
      setVisible(false);
    }

    const handleClick = async (e) => {
      e.stopPropagation()
      const open = () => { setVisible(true) }

      if (typeof onBeforeTrigger === 'function') {
        onBeforeTrigger(open);
        return;
      }
      open();
    }

    const modalProps = {
      ...rest,
      visible,
      onCancel: handleCancel,
    } as ComponentProps<T>

    return (
      <>
        {React.cloneElement(children, {
          onClick: handleClick
        })}
        {visible && <ModalComp {...modalProps} />}
      </>
    )
  }
}

export default ModalTriggerWrapper;
